import React, { useState } from 'react';
import './CustomConfirm.css'


const CustomConfirm = ({ message, onConfirm, onCancel }) => {



  return (
    <div className="custom-confirm">
      <p>{message}</p>
      <button onClick={onConfirm} className='stornoBtn'>Stornovat objendávku</button>
      <button onClick={onCancel}>NE</button>
    </div>
  );
};


export default CustomConfirm;